Instructions for posting the job ad.
